import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {SpecialtyDentalGuideModel} from 'domain/usecases';
import {OdontoGuideServicesTypeEnum} from 'presentation/constants';
import {UseOdontoSpecialtiesGuideQueryParams} from './types';
import {getOdontoSpecialties} from '../../services/getOdontoSpecialties';

export function useOdontoSpecialtiesGuideQuery({
	enabled,
	...params
}: UseOdontoSpecialtiesGuideQueryParams) {
	const shouldFetchOdontoSpecialties = Boolean(
		params.cdUf &&
		params.service === OdontoGuideServicesTypeEnum.OUTPATIENT &&
		params.cdPlanoANS.length,
	);

	return useQuery<SpecialtyDentalGuideModel[]>({
		queryKey: [QUERY_KEYS.ODONTO_SPECIALTIES_GUIDE, params],
		queryFn: ({signal}) =>
			getOdontoSpecialties({
				cdPlanoANS: params.cdPlanoANS,
				cdUf: params.cdUf,
				signal,
			}),
		enabled: shouldFetchOdontoSpecialties && enabled !== false,
	});
}
